/**
 *@file fdDataTable
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:48
 *@updateTime 2019/10/17 - 20:48
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 @description fdDataTable 是前端的数据字典表，自己按照项目需求看是否需要
 */
const fdDataTable = {
    table20191: {
        table1: '是',
        table2: '否'
    },
    hsfyList: {
        zgrmfy: [
            {
                name: '最高人民法院',
                code: 'http://www.court.gov.cn/'
            }
        ],
        dffy: [
            {
                name: '辽宁省高级人民法院',
                code: 'http://ln.lncourt.gov.cn/index.shtml'
            },
            {
                name: '天津市高级人民法院',
                code: 'https://tjfy.tjcourt.gov.cn/index.shtml'
            },
            {
                name: '山东省高级人民法院',
                code: 'http://www.sdcourt.gov.cn/'
            },
            {
                name: '江苏省高级人民法院',
                code: 'http://www.jsfy.gov.cn/'
            },
            {
                name: '上海市高级人民法院',
                code: 'http://www.hshfy.sh.cn/shfy/web/'
            },
            {
                name: '湖北省高级人民法院',
                code: 'http://www.hbfy.gov.cn/'
            },
            {
                name: '浙江省高级人民法院',
                code: 'https://www.zjsfgkw.gov.cn/'
            },
            {
                name: '福建省高级人民法院',
                code: 'http://www.fjcourt.gov.cn/'
            },
            {
                name: '广东省高级人民法院',
                code: 'http://www.gdcourts.gov.cn/'
            },
            {
                name: '广西壮族自治区高级人民法院',
                code: 'https://gxfy.gxcourt.gov.cn/index.shtml'
            },
            {
                name: '海南省高级人民法院',
                code: 'http://www.hicourt.gov.cn/'
            }
        ],
        hsfy: [
            {
                name: '大连海事法院',
                code: 'https://www.dlhsfy.gov.cn/'
            },
            {
                name: '天津海事法院',
                code: 'https://tjhsfy.tjcourt.gov.cn/index.shtml'
            },
            {
                name: '青岛海事法院',
                code: 'http://qdhsfy.sdcourt.gov.cn/'
            },
            {
                name: '南京海事法院',
                code: 'http://www.njhsfy.gov.cn/'
            },
            {
                name: '上海海事法院',
                code: 'http://shhsfy.gov.cn/'
            },
            {
                name: '武汉海事法院',
                code: 'http://whhsfy.hbfy.gov.cn/'
            },
            {
                name: '宁波海事法院',
                code: 'http://www.nbhsfy.cn/'
            },
            {
                name: '厦门海事法院',
                code: 'http://www.xmhsfy.gov.cn/'
            },
            {
                name: '广州海事法院',
                code: 'https://www.gzhsfy.gov.cn/'
            },
            {
                name: '北海海事法院',
                code: 'https://www.bhhsfy.gov.cn/'
            },
            {
                name: '海口海事法院',
                code: 'http://hsfy.hicourt.gov.cn/'
            }
        ]
    },
    // 有效性
    yyxList: [
        {
            name: '现行有效',
            code: '1'
        },
        {
            name: '已废止',
            code: '0'
        }
    ],
    // 法律位阶
    flwjList: [
        {
            name: '法律',
            code: '0'
        },
        {
            name: '法规',
            code: '1'
        },
        {
            name: '规范性文件',
            code: '2'
        },
        {
            name: '其他',
            code: '99'
        }
    ],
    // 法院公告的tab数据
    fyggList: [

        {
            name: '开庭',
            code: '7'
        },
        {
            name: '送达',
            code: '6'
        },
        {
            name: '宣告',
            code: '8'
        },
        {
            name: '催告',
            code: '9'
        },
        {
            name: '拍/变卖',
            code: '10'
        },
        {
            name: '其他',
            code: '12'
        }
    ],
    // 法院介绍的tab数据
    fyjsList: [
        {
            name: '最高人民法院',
            code: '0'
        },
        {
            name: '高级人民法院',
            code: '1100'
        },
        {
            name: '海事法院',
            code: '1129'
        }
    ],
    // 扣押的tab数据
    kyList: [
        {
            name: '船舶扣押',
            code: 'cbky'
        }
        // {
        //     name: '其他扣押',
        //     code: 'qtky'
        // }
    ],
    // 拍卖的tab数据
    pmList: [
        {
            name: '船舶拍卖',
            code: 'cbpm'
        },
        {
            name: '其他拍卖',
            code: 'qtpm'
        },

        {
            name: '拍卖分析',
            code: 'pmfx'
        }
    ],
    // 海事案例的tab切换
    hsalList: [
        {
            name: '指导性案例',
            code: '0'
        },
        {
            name: '公报案例',
            code: '1'
        },
        {
            name: '典型案例',
            code: '2'
        },
        {
            name: '地方法院精选案例',
            code: '18'
        }
    ],
    // 理论探讨的tab切换
    llttList: [
        {
            name: '调研文章',
            code: '3'
        },
        {
            name: '审判年刊',
            code: '4'
        }
    ],
    // 审判通报的tab切换
    sptbList: [
        {
            name: '白皮书',
            code: '5'
        },
        {
            name: '司法建议',
            code: '6'
        }
    ],
    // 域外司法的tab切换
    ywsfList: [
        {
            name: '域外法治动态',
            code: '11'
        },
        {
            name: '域外法律',
            code: '10'
        },
        {
            name: '域外仲裁',
            code: '12'
        },
        {
            name: '域外判决',
            code: '13'
        }
        // {
        //     name: '条约与惯例',
        //     code: '14'
        // }
    ],
    // 海事仲裁的tab切换
    hszcList: [
        {
            name: '仲裁简介',
            code: '15'
        },
        {
            name: '案例分析',
            code: '16'
        },
        {
            name: '研究报告',
            code: '17'
        }
    ],
    // 法院的tab切换
    fyList: [
        {
            name: '最高人民法院',
            code: 'zgrmfy'
        },
        {
            name: '高级人民法院',
            code: 'dffy'
        },
        {
            name: '海事法院',
            code: 'hsfy'
        }
    ],
    // 审判通报的tab切换
    sfwjList: [
        {
            name: '司法解释',
            code: '7'
        },
        {
            name: '法律法规',
            code: '8'
        },
        {
            name: '指导性文件',
            code: '9'
        }
    ],
    barOptions: {
        tooltip: {
            borderWidth: 0,
            backgroundColor: 'transparent',
            formatter: function (params) {
                let formatterVal = '<div class=\'fd-map-tooltip-01\'>';
                formatterVal += `<p class='fd-map-title'>${params.seriesName}</p>`;
                formatterVal += `<p class="fd-map-text">${params.name}<span>${params.data}<em>件</em></span></span></p>`;
                return formatterVal;
            }
        },
        // 图例的样式
        legend: {
            icon: 'rect',
            itemWidth: 8,
            itemHeight: 8,
            right: 100,
            top: 0,
            itemGap: 40,
            color: '#40444d',
            selectedMode:false,
            textStyle:{
                fontSize:14,
                lineHeight:28
            }
        },
        // 当前有效绘制区域的占位
        grid: {right: 0, top: 60, left: 80, bottom:40},
        xAxis: {
            axisLine: {lineStyle: {color: '#ededed'}},
            axisLabel: {
                color: '#40444d',
                fontSize: 14
            },
            axisTick: {show: false},
            data: ['大连', '天津', '青岛', '南京', '上海', '武汉', '宁波', '厦门', '广州', '北海', '海口']
        },
        yAxis: {
            type: 'value',
            axisLine: {show: false},
            lineStyle: {
                show: true,
                color: 'red'
            },
            axisLabel: {
                color: '#40444d',
                fontSize: 14
            },
            splitLine: {show: true, lineStyle: {color: '#ededed'}},
            axisTick: {show: false}
        },
        series: [
            {
                name: '新收',
                type: 'bar',
                barWidth: 20,
                z: 0,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 1,
                        y2: 0,
                        colorStops: [
                            {
                                offset: 0,
                                color: '#527cf7'
                            },
                            {
                                offset: 0.5,
                                color: '#79b1f6'
                            },
                            {
                                offset: 1,
                                color: '#2f60f8'
                            }
                        ],
                        global: false
                    }
                },
                data: []
            },
            {
                z: 2,
                type: 'pictorialBar',
                symbol: 'circle',
                silent: true,
                symbolPosition: 'end',
                symbolOffset: ['-26', '-2'],
                symbolSize: ['20', '4'],
                itemStyle: {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#093890'
                                },
                                {
                                    offset: 1,
                                    color: '#79B5F6'
                                }
                            ],
                            global: false
                        }
                    }
                },
                data: []
            },
            {
                name: '结案',
                type: 'bar',
                barWidth: 20,
                z: 0,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 1,
                        y2: 0,
                        colorStops: [
                            {
                                offset: 0,
                                color: '#1F848C'
                            },
                            {
                                offset: 0.5,
                                color: '#79E8F6'
                            },
                            {
                                offset: 1,
                                color: '#148C92'
                            }
                        ],
                        global: false
                    }
                },
                data: []
            },
            {
                z: 2,
                silent: true,
                type: 'pictorialBar',
                symbol: 'circle',
                symbolPosition: 'end',
                symbolOffset: ['0', '-2'],
                symbolSize: ['20', '4'],
                itemStyle: {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#79EEF6'
                                },
                                {
                                    offset: 1,
                                    color: '#095E90'
                                }
                            ],
                            global: false
                        }
                    }
                },
                data: []
            },
            {
                name: '未结',
                type: 'bar',
                barWidth: 20,
                z: 0,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 1,
                        y2: 0,
                        colorStops: [
                            {
                                offset: 0,
                                color: '#1B299A'
                            },
                            {
                                offset: 0.5,
                                color: '#7989F6'
                            },
                            {
                                offset: 1,
                                color: '#1620AC'
                            }
                        ],
                        global: false
                    }
                },
                data: []
            },
            {
                z: 2,
                silent: true,
                type: 'pictorialBar',
                symbol: 'circle',
                symbolPosition: 'end',
                symbolOffset: ['26', '-2'],
                symbolSize: ['20', '4'],
                itemStyle: {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#091490'
                                },
                                {
                                    offset: 1,
                                    color: '#79A2F6'
                                }
                            ],
                            global: false
                        }
                    }
                },
                data: []
            }
        ]
    },
    // 海事法院code和省份的对照表
    hsfyCode: {
        '732': '辽宁',
        '72': '天津',
        '2010': '山东',
        '1151': '江苏',
        '1129': '上海',
        '2367': '湖北',
        '1402': '浙江',
        '1693': '福建',
        '2701': '广州',
        '2878': '广西',
        '2925': '海南'
    }
};
export default fdDataTable;
